/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function EducationSection() {
  return (
    <MKBox
      bgColor="#343434"
      borderRadius="xl"
      shadow="lg"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      mt={{ xs: 10, sm: 10, md: 10 }}
      mb={{ xs: 10, sm: 10, md: 10 }}
      mx={3}
    >
      <MKBox
        variant="gradient"
        bgColor="info"
        coloredShadow="secondary"
        borderRadius="lg"
        p={2}
        mx={2}
        mt={-3}
      >
        <MKTypography
          variant="h1"
          color="white"
          sx={{ overflowWrap: "break-word", textAlign: "center" }}
        >
          Education
        </MKTypography>
      </MKBox>
      <MKBox p={3}>
        <MKTypography variant="h5" color="white">
          Bachelor of Science, Applied Mathematics and Computer Science: Software Development
        </MKTypography>
        <MKTypography variant="body2" color="white" mb={3} ml={2}>
          University of Wisconsin - Stout (Sept. 2006 - May 2009; Menomonie, WI.)
        </MKTypography>
        <MKTypography variant="h5" color="white">
          Associate Degree in Information Technology - Programmer / Analyst
        </MKTypography>
        <MKTypography variant="body2" color="white" mb={3} ml={2}>
          Northcentral Technical College (2004 - 2006; Wausau, WI.)
        </MKTypography>
      </MKBox>
    </MKBox>
  );
}

export default EducationSection;
